// @flow

import * as React from "react";
import { FormGroup, Col, ControlLabel, Radio } from "react-bootstrap";

import "./LikertForm.css";

type LikertRadioProps = {
  group: string,
  value: number,
  label: string,
  isSelected: boolean,
  onChange: number => void
};

const LikertRadio = (props: LikertRadioProps) => (
  <Radio
    name={props.group}
    value={props.value}
    checked={props.isSelected}
    onChange={e => props.onChange(parseInt(e.target.value, 10))}
  >
    {" "}
    {props.label}
  </Radio>
);

type LikertFormProps = {
  name: string,
  label: string,
  value?: number,
  onChange: number => void,
  sm: number
};

const LikertForm = (props: LikertFormProps) => {
  const items = [
    { value: 1, label: "1 (Poor)" },
    { value: 2, label: "2" },
    { value: 3, label: "3" },
    { value: 4, label: "4" },
    { value: 5, label: "5 (Excellent)" }
  ];
  return (
    <FormGroup className="LikertForm" controlId={`form${props.name}`}>
      <Col sm={props.sm}>
        <ControlLabel>{props.label}</ControlLabel>
        <div className="LikertFormControl">
          {items.map(item => (
            <LikertRadio
              group={`radioGroup${props.name}`}
              value={item.value}
              label={item.label}
              key={item.value}
              isSelected={(props.value || -1) === item.value}
              onChange={props.onChange}
            />
          ))}
        </div>
      </Col>
    </FormGroup>
  );
};

export default LikertForm;



// WEBPACK FOOTER //
// ./src/components/LikertForm/LikertForm.js